import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '@mui/icons-material/Error';

import { withStyles } from '~/assets/withStyles';
import CircularProgress from '~/components/core/Atomic/CircularProgress/CircularProgress';

import styles from '../assets/styles';

const LoadingIndicatorContainer = ({ children }) => {
  return <div className="flex items-center justify-center">{children}</div>;
};

LoadingIndicatorContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const LoadingIndicator = ({
  classes = {},
  isError = false,
  LoadingComponent = undefined,
  ErrorComponent = undefined,
  ...rest
}) => {
  if (isError) {
    return (
      <LoadingIndicatorContainer>
        {ErrorComponent ? (
          <ErrorComponent />
        ) : (
          // Using data-testid since we can't fetch the SVG by other functionality
          <ErrorIcon data-testid="error-indicator" style={{ fontSize: 30 }} className={classes.loading} />
        )}
      </LoadingIndicatorContainer>
    );
  }

  return (
    <LoadingIndicatorContainer>
      {LoadingComponent ? (
        <LoadingComponent />
      ) : (
        // Using data-testid since we can't fetch the SVG by other functionality
        <CircularProgress data-testid="loading-indicator" className={classes.loading} {...rest} />
      )}
    </LoadingIndicatorContainer>
  );
};

LoadingIndicator.propTypes = {
  classes: PropTypes.object,
  isError: PropTypes.bool,
  LoadingComponent: PropTypes.elementType,
  ErrorComponent: PropTypes.elementType,
};

export default withStyles(LoadingIndicator, styles);
